module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-home",
    class: {
      'hero-home--active': _vm.active
    }
  }, [_c('NavTrigger', {
    staticClass: "hero-home__trigger--1",
    attrs: {
      "props": 0
    }
  }), _c('NavTrigger', {
    staticClass: "hero-home__trigger--2",
    attrs: {
      "props": 1
    }
  }), _c('NavTrigger', {
    staticClass: "hero-home__trigger--3",
    attrs: {
      "props": 2
    }
  }), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-home__background",
    staticStyle: {
      "backgroundImage": "url(static/home-hero-1.jpg)"
    }
  }, [_c('div', {
    staticClass: "hero-home__container"
  }, [_c('div', {
    staticClass: "hero-home__row"
  }, [_c('div', {
    staticClass: "sm-offset-8"
  }), _c('div', {
    staticClass: "hero-home__text-box"
  }, [_c('div', {
    staticClass: "hero-home__text"
  }, [_vm._v(" One Doctor–one team")]), _c('div', {
    staticClass: "hero-home__text hero-home__text--alt"
  }, [_vm._v("One great smile")]), _c('div', {
    staticClass: "hero-home__text hero-home__text--alt2"
  }, [_vm._v(" for each patient")])]), _c('div', {
    staticClass: "hero-home__text-box hero-home__text-box--mobile"
  }, [_c('div', {
    staticClass: "hero-home__text"
  }, [_vm._v(" One Doctor")]), _c('div', {
    staticClass: "hero-home__text hero-home__text--alt"
  }, [_vm._v("one team")]), _c('div', {
    staticClass: "hero-home__text hero-home__text--alt"
  }, [_vm._v("One great")]), _c('div', {
    staticClass: "hero-home__text hero-home__text--alt2"
  }, [_vm._v(" smile for")]), _c('div', {
    staticClass: "hero-home__text hero-home__text--alt2"
  }, [_vm._v(" each patient")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a496f33c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero/hero-home/hero-home.pug
// module id = 661
// module chunks = 1